import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private authenticationService: AuthenticationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('currentUser')) {
            return true;
        }

        this.authenticationService.redirectUrl = state.url;
        this.router.navigate(['/pages/login']);
        return false;
    }
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/pages/login/auth.guard.ts